<template>
  <div id="app">
    <v-app>
      <Header/>
      <v-main v-show="!$store.state.isLoadingKV">
        <IntroductionHome></IntroductionHome>
        <v-container>
          <Step1/>
          <Step2/>
          <Step3/>
          <GenerateBtn
          :nameForm="nameForm"
          :titleForm="titleForm"
          :contentForm="contentForm"
          :imgForm="imgForm"></GenerateBtn>
          <section class="sec-overlay">
            <div class="mod-endCampaign" id="prg-endCampaign">
              <p class="mod-endCampaign__endImage" id="prg-endImage">キャンペーンは終了しました</p>
            </div>
          </section>
        </v-container>
      </v-main>
      <SecFooter/>
      <Footer v-show="!$store.state.isLoadingKV" />
    </v-app>
  </div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import IntroductionHome from './components/IntroductionHome.vue';
import Step1 from './components/Step1.vue';
import Step2 from './components/Step2.vue';
import Step3 from './components/Step3.vue';
import GenerateBtn from './components/GenerateBtn.vue';
import SecFooter from './components/SecFooter.vue';
import {mapGetters, mapActions} from 'vuex';

export default {
  components:{
    IntroductionHome,
    Step1,
    Step2,
    Step3,
    GenerateBtn,
    SecFooter,
    Header,
    Footer
  },
  data(){
    return {
      nameForm:"",
      titleForm:"",
      contentForm:"",
      imgForm:"",
    }
  },
  created(){
    this.$store.state.headers = {
      "X-CSRF-TOKEN": "auth"
    }
    this.initAction({
      generatedImg: "generatedImg",
      name: "autherName"
    });
  },
  mounted(){
    this.nameForm = this.$el.querySelector("#nameForm");
    this.titleForm = this.$el.querySelector("#titleForm");
    this.contentForm = this.$el.querySelector("#contentForm");
    this.imgForm = this.$el.querySelector("#imgForm");
    let last_known_scroll_position = 0;
    let endImage = this.$el.querySelector("#prg-endImage");
    let secFooterWrap = this.$el.querySelector(".sec-footer-wrap")
    window.addEventListener("scroll", function(){
      last_known_scroll_position = window.scrollY;
      if (last_known_scroll_position > 3000){
        endImage.classList.add("hide");
        secFooterWrap.classList.add("upIndex")
      }else{
        endImage.classList.remove("hide")
        secFooterWrap.classList.remove("upIndex")
      }
    })
  },
  computed: {
    ...mapGetters(['checkTheme']),
  },
  methods: {
    ...mapActions(['initAction']),
  }
}
</script>

<style>
@charset "UTF-8";
@font-face {
  font-family: "LIFULLFONT-Regular";
  src: url("./assets/fonts/LIFULLFont-Regular.otf");
  src: url("./assets/fonts/LIFULLFont-Regular.woff");
}

@font-face {
  font-family: "LIFULLFONT-Bold";
  src: url("./assets/fonts/LIFULLFont-Bold.otf");
  src: url("./assets/fonts/LIFULLFont-Bold.woff");
}

html {
  -webkit-overflow-scrolling: touch;
}

.v-toolbar__content {
  display: block !important;
}
.sec-overlay{
      position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,.5);
    overflow: hidden;
    z-index: 50;
}
.hide{
  opacity: 0;
}
.upIndex{
  z-index: 300;
}
.mod-endCampaign{
    position: fixed;
    top: 50px;
    right: 0;
    bottom: 0;
    left: 0;
    min-width: 320px;
    margin: 0 auto;
    opacity: 1;
    visibility: visible;
    transition: .2s;
    z-index: 100;
}
.mod-endCampaign__endImage{
  position: absolute;
    top: calc(50% - 50px);
    right: auto;
    bottom: auto;
    left: 50%;
    width: 656px;
    height: 179px;
    background-image: url("./assets/end.png");
    background-size: contain;
    transform: rotate(
-10deg
) translate(-50%, -60%);
    text-indent: -9999px;
    transition: opacity 0.2s;
    transform-origin: top;
}
.v-toolbar__content, .v-toolbar__extension {
  padding: 0px !important;
}

.generateBtn .v-progress-circular {
  height: 50px !important;
  width: 50px !important;
}

.generateBtn .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #B7B7B7 !important;
}

.generateBtn .theme--light.v-btn.v-btn--disabled {
  color: #f5f5f5 !important;
}

.barlow {
  font-family: 'Barlow', sans-serif;
}

.lifullFont {
  font-family: "LIFULLFONT-Regular", sans-serif;
}

.lifullFontBold {
  font-family: "LIFULLFONT-Bold", sans-serif;
}

.v-application {
  font-family: "游ゴシック体", "YuGothic", "游ゴシック", "Yu Gothic", "メイリオ", "Meiryo", sans-serif !important;
}

.bold {
  font-family: "游ゴシック体", YuGothic, "游ゴシック", "Yu Gothic", sans-serif;
  font-weight: bold !important;
}

.bcol {
  color: #ed6103;
}

.bg_bcol {
  background-color: #ed6103;
}

.main_title {
  font-size: 50px;
}

.title-line {
  background-repeat: repeat-x;
  background-size: 12px 100%;
  height: 6px;
}

.title-img {
  position: absolute;
  height: 45px !important;
  top: 50%;
  left: 50%;
  background-color: white;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
}

@media only screen and (max-width: 599px) {
  .title-img {
    height: 30px !important;
  }
}

.main_hr {
  border: 2px solid #FFAB00;
  border-radius: 2px;
}

.last_hr {
  border: 2px solid #E6E6E6;
  margin-bottom: 60px;
}

.subtitle {
  font-weight: bold;
  font-size: 20px;
}

.tmptitle {
  font-weight: bold;
  font-size: 14px;
}

.bg_gray {
  background-color: #F5F5F5;
}

.tmptwotitle {
  font-weight: bold;
  font-size: 14px;
}

.main_btn {
  border-radius: 40px !important;
  height: 80px !important;
  min-width: 324px !important;
  -webkit-box-shadow: 0px 7px #e0e0e0 !important;
          box-shadow: 0px 7px #e0e0e0 !important;
}

.main_btn.disabled {
  -webkit-box-shadow: 0px 0px #e0e0e0 !important;
          box-shadow: 0px 0px #e0e0e0 !important;
}

.main_btn span {
  font-size: 24px !important;
  text-transform: none !important;
}

.main_btn:active {
  -webkit-box-shadow: 0 2px #B7B7B7 !important;
          box-shadow: 0 2px #B7B7B7 !important;
}

.generateBtn:active {
  -webkit-transform: translateY(6px);
          transform: translateY(6px);
}

.head_img {
  position: absolute;
  -webkit-transform: translate(0px, -70px);
          transform: translate(0px, -70px);
  width: 186px;
}

.hand_img {
  position: absolute;
  -webkit-transform: translate(0px, -8px);
          transform: translate(0px, -8px);
  z-index: 1;
  width: 184px;
}

@media all and (-ms-high-contrast: none) {
  .head_img {
    position: absolute;
    -webkit-transform: translate(-150px, -114px);
            transform: translate(-150px, -114px);
  }
  .hand_img {
    position: absolute;
    -webkit-transform: translate(-150px, -14px);
            transform: translate(-150px, -14px);
    z-index: 1;
  }
  .v-application--wrap {
    display: block !important;
  }
}

.cropBtn span {
  font-weight: bold;
  font-size: 20px;
}

.centering {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.hidden {
  visibility: hidden;
}

.rounded_right {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.rounded_bottom {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.theme--light.v-file-input .v-file-input__text--placeholder {
  color: #ed6103 !important;
}

.text-line-right {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.text-line-right:after {
  content: "";
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  height: 4px;
  background: #FFAB00;
  display: block;
  border: 2px solid #FFAB00;
  border-radius: 2px;
}

.text-line-right:after {
  margin-left: .4em;
}

/*Chrome*/
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  input[type='range']::-webkit-slider-runnable-track {
    background: #edc203;
  }
  input[type='range']::-webkit-slider-thumb {
    background: #ed6103;
  }
}

.croppie-container .cr-viewport, .croppie-container .cr-resizer {
  border: 2px solid #ed6103 !important;
}

.lsizebtn .v-badge--avatar .v-badge__badge .v-avatar {
  height: 40px !important;
  min-width: 0 !important;
  max-width: 40px !important;
}

.smart_only {
  display: none;
}

.contentForm .v-text-field__details {
  -webkit-transform: translate(0px, 76px) !important;
          transform: translate(0px, 76px) !important;
}

.error-col fieldset {
  color: #FF5252 !important;
}

@media only screen and (max-width: 599px) {
  .smart_only {
    display: block;
  }
  .hand_img {
    width: 185px;
    -webkit-transform: translate(0px, -8px);
            transform: translate(0px, -8px);
  }
  .head_img {
    width: 183px;
    -webkit-transform: translate(0px, -68px);
            transform: translate(0px, -68px);
  }
}

@media only screen and (max-width: 959px) {
  .titleForm .v-text-field__details {
    -webkit-transform: translate(0px, 55px) !important;
            transform: translate(0px, 55px) !important;
  }
  .last_hr {
    margin-bottom: 50px;
  }
  .contentForm .v-input__slot {
    height: 98px !important;
  }
  .contentForm .v-text-field__details {
    -webkit-transform: translate(0px, 96px) !important;
            transform: translate(0px, 96px) !important;
  }
}

.modal-content .croppie-container .cr-slider-wrap {
  width: 75%;
  margin: 17.5px auto;
  text-align: center;
}

@media only screen and (max-width: 769px) {
  .main_title {
    font-size: 35px;
  }
  .subtitle {
    font-weight: bold;
    font-size: 16px;
  }
  .tmptitle {
    font-weight: bold;
    font-size: 12px;
  }
  .mod-endCampaign__endImage{
    width: 500px;
    height: 202px;
    background-image: url("./assets/end_sp.png");
    transform: rotate(
-10deg
) translate(-50%, -60%);
  }
}

@media (min-width: 1904px) {
  .container {
    max-width: 972px !important;
  }
}

@media (min-width: 1264px) {
  .container {
    max-width: 972px !important;
  }
}

@media (min-width: 960px) {
  .container {
    max-width: 972px !important;
  }
}

.typewriter_title_box {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  text-align: center;
  height: 100%;
  margin: 0px auto;
  font-size: 5vw;
  font-weight: bold;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-transform: translate(0px, -6px);
          transform: translate(0px, -6px);
}

_::-webkit-full-page-media, _:future, :root .typewriter_title_box {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  text-align: center;
  height: 100%;
  margin: 0px auto;
  font-size: 5vw;
  font-weight: bold;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
          justify-content: center;
  -webkit-box-align: center;
          align-items: center;
}

_::-webkit-full-page-media, _:future, :root .title_line3 {
  letter-spacing: -0.2vw;
  display: inline-block;
}

.typewriter_title_box_wrapper {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.st0 {
  color: #ED6103;
}

.st1 {
  color: #FFAB00;
}

.title_line1 {
  letter-spacing: 0.5vw;
  display: inline-block;
  vertical-align: middle;
}

.title_line2 {
  letter-spacing: 0.2vw;
  font-size: 7.5vw;
  display: inline-block;
}

.title_line3 {
  letter-spacing: -0.2vw;
  display: inline-block;
}

.title_line1_wrapper {
  display: inline-block;
  width: 0%;
  -webkit-transform: translate(0vw, 1.2vw);
          transform: translate(0vw, 1.2vw);
  border-right: 6px solid transparent;
  overflow: hidden;
  white-space: nowrap;
  -webkit-animation: blinkTextCursor 0.5s steps(25) 0s 3 alternate, title_line1_move 0.6s steps(6) 1.5s 1, moveTextCursor 0.6s steps(6) 1.5s 1;
          animation: blinkTextCursor 0.5s steps(25) 0s 3 alternate, title_line1_move 0.6s steps(6) 1.5s 1, moveTextCursor 0.6s steps(6) 1.5s 1;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}

.title_line2_wrapper {
  display: inline-block;
  width: 0%;
  -webkit-transform: translate(0vw, 0.5vw);
          transform: translate(0vw, 0.5vw);
  border-right: 6px solid transparent;
  overflow: hidden;
  white-space: nowrap;
  -webkit-animation: title_line2_move 0.8s steps(6) 2.1s 1, moveTextCursor 0.8s steps(6) 2.1s 1;
          animation: title_line2_move 0.8s steps(6) 2.1s 1, moveTextCursor 0.8s steps(6) 2.1s 1;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}

.title_line3_wrapper {
  display: inline-block;
  width: 0%;
  -webkit-transform: translate(-1.2vw, -0.1vw);
          transform: translate(-1.2vw, -0.1vw);
  border-right: 6px solid transparent;
  overflow: hidden;
  white-space: nowrap;
  -webkit-animation: title_line3_move 0.8s steps(6) 2.9s 1, moveTextCursor 0.8s steps(6) 2.9s 1, blinkTextCursor 0.5s steps(25) 3.7s infinite alternate;
          animation: title_line3_move 0.8s steps(6) 2.9s 1, moveTextCursor 0.8s steps(6) 2.9s 1, blinkTextCursor 0.5s steps(25) 3.7s infinite alternate;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}

@media only screen and (max-width: 599px) {
  .title_line1_wrapper {
    -webkit-transform: translate(0.2vw, 1.9vw);
            transform: translate(0.2vw, 1.9vw);
    border-right: 4px solid transparent;
  }
  .title_line2_wrapper {
    -webkit-transform: translate(0.3vw, 0.6vw);
            transform: translate(0.3vw, 0.6vw);
    border-right: 4px solid transparent;
  }
  .title_line3_wrapper {
    -webkit-transform: translate(-2vw, -0.6vw);
            transform: translate(-2vw, -0.6vw);
    border-right: 4px solid transparent;
  }
}

@-webkit-keyframes title_line1_move {
  0% {
    width: 0%;
  }
  100% {
    width: 45%;
  }
}

@keyframes title_line1_move {
  0% {
    width: 0%;
  }
  100% {
    width: 45%;
  }
}

@-webkit-keyframes title_line2_move {
  0% {
    width: 0%;
  }
  100% {
    width: 99%;
  }
}

@keyframes title_line2_move {
  0% {
    width: 0%;
  }
  100% {
    width: 99%;
  }
}

@-webkit-keyframes title_line3_move {
  0% {
    width: 0%;
  }
  100% {
    width: 97%;
  }
}

@keyframes title_line3_move {
  0% {
    width: 0%;
  }
  100% {
    width: 97%;
  }
}

@-webkit-keyframes moveTextCursor {
  0% {
    border-right-color: transparent;
  }
  1% {
    border-right-color: #ed6103;
  }
  99% {
    border-right-color: #ed6103;
  }
  100% {
    border-right-color: transparent;
  }
}

@keyframes moveTextCursor {
  0% {
    border-right-color: transparent;
  }
  1% {
    border-right-color: #ed6103;
  }
  99% {
    border-right-color: #ed6103;
  }
  100% {
    border-right-color: transparent;
  }
}

@-webkit-keyframes blinkTextCursor {
  from {
    border-right-color: transparent;
  }
  to {
    border-right-color: #ed6103;
  }
}

@keyframes blinkTextCursor {
  from {
    border-right-color: transparent;
  }
  to {
    border-right-color: #ed6103;
  }
}

@media only screen and (max-width: 599px) {
  .typewriter_title_box {
    font-size: 10vw;
    -webkit-transform: translate(0px, -5px);
            transform: translate(0px, -5px);
  }
  _::-webkit-full-page-media, _:future, :root .typewriter_title_box {
    font-size: 10vw;
    -webkit-transform: translate(0px, -5px);
            transform: translate(0px, -5px);
  }
  .typewriter_title_box_wrapper {
    -webkit-transform: translate(0px, -14vw);
            transform: translate(0px, -14vw);
  }
  .title_line1 {
    letter-spacing: 1vw;
  }
  .title_line2 {
    letter-spacing: 0.3vw;
    font-size: 15vw;
    display: inline-block;
  }
  .title_line3 {
    letter-spacing: -0.4vw;
    display: inline-block;
  }
}
.section-contents{
  margin: 0;
  padding: 0;
}
/*# sourceMappingURL=util.css.map */
</style>
